module.exports = __webpack_public_path__ + "static/media/plusicon-on-hover.660319cf.svg";